<template>
	<div class="display-flex flex-row flex-align-center">
		<SIcon height="13" width="11" class="mr-1" name="num-of-teams-saved" />
		<h5 class="liked">{{ numOfTeamsText }} saved this</h5>
	</div>
</template>

<script>
import { pluralize } from '@/utils/language-service';

function hash(str) {
	let result = 0;
	for (let i = 0; i < str.length; i++) {
		result += str.charCodeAt(i);
	}
	return result;
}

function hashToNumber(str) {
	const hashValue = hash(str);
	const number = hashValue % 15;
	return number + 20;
}

export default {
	name: 'TeamsLikedSpan',
	props: {
		numOfTeams: { type: Number }, // for now we are not using this prop
		ideaId: { type: String },
	},
	computed: {
		numOfTeamsText() {
			return pluralize('team', this.prettierNumOfTeams + this.numOfTeams, true);
		},
		prettierNumOfTeams() {
			return hashToNumber(this.ideaId);
		},
	},
};
</script>

<style lang="scss" scoped>
.liked {
	color: #98a2b7;
}
</style>
